import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LocalStorageService } from 'app/core/local-storage/local-storage.service';
import {
    OpenTransactionTab,
    TabActions,
} from '../actions/transaction-tab.actions';
import { EMPTY, Observable, exhaustMap} from 'rxjs';

@Injectable()
export class TransactionTabEffects {
    constructor(
        private actions$: Actions,
        private localStorageService: LocalStorageService
    ) {}

    setLocalStorage$ = createEffect(() =>
        this.actions$.pipe(
            ofType<OpenTransactionTab>(TabActions.OpenTransactionTab),
            exhaustMap((action) => {
                const openedTransactionTabList: string[] | null =
                    this.localStorageService.getDataFromLocalStorage(
                        'openedTransactionTabList'
                    );
                if (Array.isArray(openedTransactionTabList) && action.transactionId) {
                    const data = openedTransactionTabList.includes(
                        action.transactionId
                    )
                        ? [...openedTransactionTabList]
                        : [...openedTransactionTabList, action.transactionId];
                    this.localStorageService.setDataInLocalStorage(
                        'openedTransactionTabList',
                        data
                    );
                }
                return EMPTY as Observable<any>
            })
        )
    );
}
